<template>
  <v-container
    fluid
    class="px-0"
  >
    <tabela
      :item="item"
      :loading="loading"
      @rechargeTable="getAll()"
    />
  </v-container>
</template>

<script>
import PerfisService from '@/services/PerfisService';

export default {
  components: {
    Tabela: () => import('@/components/perfis/Tabela.vue')
  },

  data: () => ({
    item: [],
    loading: false
  }),

  mounted() {
    this.getAll();
  },

  methods: {
    getAll() {
      this.loading = true;

      PerfisService.getAll()
        .then(response => this.item = response.data.data)
        .catch (error => {
          console.error(error);
          this.$toast.error('Erro ao recuperar perfis de usuários.', '', {position:'topRight'});
        }) 
        .finally(() => this.loading = false);
    }
  }
};
</script>
